import { useUserStore } from '@/stores/user'
import { arrayWrap } from '@/utils/utils'
import { type RouteMeta, type RouteRecordRaw, useRouter } from 'vue-router'

type RouteFlattenFn = (filterFn: RouteFilterFn) => Array<RouteRecordRaw>
type RouteFilterFn = (route: RouteRecordRaw) => boolean

export function useRouteMeta(): {
  meta: RouteMeta
  flatRoutes: RouteFlattenFn
  isGamePlayRoute: (currentRouteName: string) => boolean
} {
  const userStore = useUserStore()
  const router = useRouter()
  const meta = router?.currentRoute.value.meta

  function isGamePlayRoute(currentRouteName: string): boolean {
    return [
      'affiliate-subscription-platinum-35',
      'checkout',
      'daily-spins',
      'instant-win',
      'instant-wins-play',
      'instant-wins-demo',
      'membership-levels-20',
      'memberships',
      'referral-box-golden-box',
      'referral-box',
      'reward-claim',
      userStore.isLoggedOut ? 'campaign' : '',
      userStore.isLoggedOut ? 'prize' : '',
    ].includes(currentRouteName)
  }

  function flatRoutes(filterFn: RouteFilterFn = () => true) {
    const flattenRoutes = (
      routes: Array<RouteRecordRaw>
    ): Array<RouteRecordRaw> => {
      return routes
        .reduce((acc: Array<RouteRecordRaw>, route: RouteRecordRaw) => {
          acc.push(route)

          if (route.children) {
            acc = acc.concat(flattenRoutes(route.children))
          }

          return acc
        }, [])
        .filter(filterFn)
    }

    // @ts-expect-error Doesn't like that the type in arrayWrap isn't readonly
    return flattenRoutes(arrayWrap(router.options.routes))
  }

  return {
    isGamePlayRoute,
    meta,
    flatRoutes,
  }
}
